import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Box, SizeUnits, TransparentButton } from '~Styles';
import { insideWrapperStyles } from '.';
import Icon from '~ComponentsImproved/Icon';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import NavigateLeftIcon from '~/Assets/icons/navigate-left.svg';
import CloseIcon from '~/Assets/icons/close.svg';

const Wrapper = styled(Box)<{ width?: string; margin?: string }>`
  position: relative;
  box-shadow: ${insideWrapperStyles.boxShadow};
  border-radius: ${insideWrapperStyles.borderRadius};
  background-color: ${insideWrapperStyles.backgroundColor};
  width: ${({ width }) => width};
  margin: ${({ margin }) => margin};
`;

const HeaderBox = styled(Box)`
  max-width: 480px;
  text-align: center;
  position: relative;
`;

export const BackButton = styled(TransparentButton)`
  position: absolute;
  top: 8px;
  left: 8px;
  color: var(--colorBlueGray800);
  font-size: 16px;
  text-transform: none;
  z-index: 100;
`;

export const BackButtonIcon = styled.div<{ isGoBack?: boolean }>`
  width: 32px;
  height: 32px;
  mask-image: url(${(props) => (props.isGoBack ? NavigateLeftIcon : CloseIcon)});
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: var(--colorBlueGray800);
  margin-right: 8px;
`;

interface Props {
  children: React.ReactNode;
  padding?: SizeUnits;
  isHandy?: boolean;
  width?: string;
  margin?: string;
  header?: {
    title?: string;
    subtitle?: string;
    icon?: string;
  };
}

/** Simple ModalWrapper with support for header, icon & subtitle */
const ModalWrapper: FC<Props> = ({
  children,
  width,
  isHandy,
  header,
  padding = 'large',
  margin,
}) => {
  return (
    <Wrapper
      display="flex"
      flexDirection="column"
      gap="medium"
      alignItems="center"
      justifyContent="center"
      padding={padding}
      marginTop="xs"
      marginBottom="xs"
      margin={margin}
      width={width}>
      {header && (
        <HeaderBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="xs"
          justifyContent="center">
          {header.icon && (
            <Icon
              height={isHandy ? '48px' : '64px'}
              width={isHandy ? '48px' : '64px'}
              src={header.icon}
              color="var(--colorBlueGray200)"
            />
          )}

          <Heading level={isHandy ? 2 : 1} color="var(--colorWhite)">
            {header.title}
          </Heading>

          {header.subtitle && (
            <Paragraph level={isHandy ? 4 : 2} color="var(--colorBlueGray200)">
              {header.subtitle}
            </Paragraph>
          )}
        </HeaderBox>
      )}

      {children}
    </Wrapper>
  );
};

export default ModalWrapper;
